export const DOMESTIC_REPORT_TYPE = 'DOMESTIC';
export const B2B_REPORT_TYPE = 'B2B';
export const GIFTCARD_SCHEME_REPORT_TYPE = 'GIFTCARD_SCHEME';
export const FC_REP_REPORT_TYPE = 'FC_REP';
export const EI_FACILITATION_REPORT_TYPE = 'EI_FACILITATION';
export const NON_EU_COUNTRY_IMPORT_REPORT_TYPE = 'NON_EU_COUNTRY_IMPORT';
export const OSS_UNION_REPORT_TYPE = 'OSS_UNION';
export const OSS_NON_UNION_REPORT_TYPE = 'OSS_NON_UNION';
export const OSS_IMPORT_REPORT_TYPE = 'OSS_IMPORT';

export const IMPORT_REPORT_TYPE = 'IMPORT';
export const NON_EU_IMPORT_REPORT_TYPE = 'NON_EU_IMPORT';
export const NON_UNION_REPORT_TYPE = 'NON_UNION';
export const UNION_REPORT_TYPE = 'UNION';

export const B2B_REPORT_PATHS = `b2b`;
export const DOMESTIC_REPORT_PATHS = `domestic`;
export const GIFTCARD_SCHEME_REPORT_PATHS = `gift-card`;
export const FC_REP_REPORT_PATHS = `ddp-ddu`;
export const EI_FACILITATION_REPORT_PATHS = `third-party-interface`;
export const NON_EU_COUNTRY_IMPORT_REPORT_PATHS = `non-eu-country-import`;
export const OSS_UNION_REPORT_PATHS = `oss`;
export const OSS_NON_UNION_REPORT_PATHS = `digital`;
export const OSS_IMPORT_REPORT_PATHS = `ioss`;

export const IMPORT_REPORT_PATHS = `import`;
export const NON_EU_IMPORT_REPORT_PATHS = `uk-import`;
export const NON_UNION_REPORT_PATHS = `non-union`;
export const UNION_REPORT_PATHS = `union`;

export const B2B_REPORT_NAME = 'em_vat_b2b_sales_csv';
export const DOMESTIC_REPORT_NAME = 'em_vat_domestic_csv';
export const GIFTCARD_SCHEME_REPORT_NAME = 'em_vat_gifts_csv';
export const FC_REP_REPORT_NAME = 'em_vat_fc_rep_csv';
export const EI_FACILITATION_REPORT_NAME = 'em_vat_ei_facilitation_csv';
export const NON_EU_COUNTRY_IMPORT_REPORT_NAME = 'em_vat_non_eu_country_import_csv';
export const OSS_UNION_REPORT_NAME = 'em_vat_oss_union_csv';
export const OSS_NON_UNION_REPORT_NAME = 'em_vat_oss_non_union_csv';
export const OSS_IMPORT_REPORT_NAME = 'em_vat_oss_import_csv';

export const IMPORT_REPORT_NAME = 'em_vat_report_generated_fiscal_import';
export const NON_EU_IMPORT_REPORT_NAME = 'non_eu_gb_fiscal_vat_report_dashboard_view';
export const NON_UNION_REPORT_NAME = 'em_vat_report_generated_fiscal_non_union';
export const UNION_REPORT_NAME = 'em_vat_report_generated_fiscal_union';

const IMPORT_REPORT_DESCRIPTION =
	'This report displays orders containing physical goods valued below 150 EUR (intrinsic value) that have been dispatched to B2C EU consumers under the IOSS special VAT scheme. The VAT rate and sum are provided for the EU country of consumption.';
const NON_EU_IMPORT_REPORT_DESCRIPTION =
	'This report displays orders containing physical goods valued below 135 GBP (intrinsic value) that have been dispatched to the B2C UK consumers under the UK low value consignment special scheme. Downloadable goods/services sold as B2C are also included in this report. The VAT rate and sum are provided for the UK.';
const NON_UNION_REPORT_DESCRIPTION =
	'This report displays orders containing downloadable goods/services that have been sold to the B2C EU consumers under the Non-union OSS special VAT scheme. The VAT rate and sum are provided for the EU country of consumption.';
const UNION_REPORT_DESCRIPTION =
	'This report displays orders containing downloadable goods/services and physical goods that have been dispatched to the B2C EU consumers under the Union OSS special VAT scheme. The VAT rate and sum are provided for the EU country of consumption.';
const DOMESTIC_REPORT_DESCRIPTION =
	'This report displays orders containing downloadable goods/services and physical goods that have been dispatched to the B2C/B2B consumers situated in the same country as the Merchant. The VAT rate and sum are provided for the country of consumption.';
const B2B_REPORT_DESCRIPTION =
	'This report displays orders containing downloadable goods/services and physical goods that have been dispatched to B2B consumers situated in another country. Reverse VAT rules (0 VAT invoice) or VAT rules for exported goods (0 VAT invoice) are applied.';
const FC_REP_REPORT_DESCRIPTION =
	'This report displays B2C orders for physical goods that are sold without application of any EU or UK special VAT schemes. VAT and customs duties for the consumption country may be applied in case of DDP orders.';
const EI_FACILITATION_REPORT_DESCRIPTION =
	'This report displays B2C orders made by EAS customers acting as online Marketplaces when the Marketplace is not responsible for collecting/paying VAT. ';

export const SALES_REPORTS = [
	{
		path: OSS_IMPORT_REPORT_PATHS,
		title: 'IOSS',
		titleDescription: 'import physical goods to EU',
		type: OSS_IMPORT_REPORT_TYPE,
		name: OSS_IMPORT_REPORT_NAME,
		description: IMPORT_REPORT_DESCRIPTION,
	},
	{
		path: DOMESTIC_REPORT_PATHS,
		title: 'Domestic EU/UK Sales',
		titleDescription: 'sales within fulfillment country',
		type: DOMESTIC_REPORT_TYPE,
		name: DOMESTIC_REPORT_NAME,
		description: DOMESTIC_REPORT_DESCRIPTION,
	},
	{
		path: B2B_REPORT_PATHS,
		title: 'B2B Cross Border Sales',
		titleDescription: 'sales to legal entities in other countries',
		type: B2B_REPORT_TYPE,
		name: B2B_REPORT_NAME,
		description: B2B_REPORT_DESCRIPTION,
	},
	{
		path: GIFTCARD_SCHEME_REPORT_PATHS,
		title: 'Gift Card Sales',
		titleDescription: 'sales of gift cards being a payment method',
		type: GIFTCARD_SCHEME_REPORT_TYPE,
		name: GIFTCARD_SCHEME_REPORT_NAME,
	},
	{
		path: FC_REP_REPORT_PATHS,
		title: 'DDP/DDU Sales',
		titleDescription: 'sales subject to standard customs procedures',
		type: FC_REP_REPORT_TYPE,
		name: FC_REP_REPORT_NAME,
		description: FC_REP_REPORT_DESCRIPTION,
	},
	{
		path: EI_FACILITATION_REPORT_PATHS,
		title: 'Marketplace Sales',
		titleDescription: 'sales acting online marketplace',
		type: EI_FACILITATION_REPORT_TYPE,
		name: EI_FACILITATION_REPORT_NAME,
		description: EI_FACILITATION_REPORT_DESCRIPTION,
	},
	{
		path: NON_EU_COUNTRY_IMPORT_REPORT_PATHS,
		title: 'UK B2C',
		titleDescription: 'special VAT scheme',
		type: NON_EU_COUNTRY_IMPORT_REPORT_TYPE,
		name: NON_EU_COUNTRY_IMPORT_REPORT_NAME,
		description: NON_EU_IMPORT_REPORT_DESCRIPTION,
	},
	{
		path: OSS_UNION_REPORT_PATHS,
		title: 'Union OSS',
		titleDescription: 'intra EU sales',
		type: OSS_UNION_REPORT_TYPE,
		name: OSS_UNION_REPORT_NAME,
		description: UNION_REPORT_DESCRIPTION,
	},
	{
		path: OSS_NON_UNION_REPORT_PATHS,
		title: 'Non-Union OSS',
		titleDescription: 'digital sales to EU',
		type: OSS_NON_UNION_REPORT_TYPE,
		name: OSS_NON_UNION_REPORT_NAME,
		description: NON_UNION_REPORT_DESCRIPTION,
	},
];

export const VAT_REPORTS = [
	{
		path: IMPORT_REPORT_PATHS,
		title: 'IOSS',
		titleDescription: 'import physical goods to EU',
		type: IMPORT_REPORT_TYPE,
		name: IMPORT_REPORT_NAME,
		description: IMPORT_REPORT_DESCRIPTION,
	},
	{
		path: NON_EU_IMPORT_REPORT_PATHS,
		title: 'UK B2C',
		titleDescription: 'special VAT scheme',
		type: NON_EU_IMPORT_REPORT_TYPE,
		name: NON_EU_IMPORT_REPORT_NAME,
		description: NON_EU_IMPORT_REPORT_DESCRIPTION,
	},
	{
		path: NON_UNION_REPORT_PATHS,
		title: 'Non-Union OSS',
		titleDescription: 'digital sales to EU',
		type: NON_UNION_REPORT_TYPE,
		name: NON_UNION_REPORT_NAME,
		description: NON_UNION_REPORT_DESCRIPTION,
	},
	{
		path: UNION_REPORT_PATHS,
		title: 'Union OSS',
		titleDescription: 'intra EU sales',
		type: UNION_REPORT_TYPE,
		name: UNION_REPORT_NAME,
		description: UNION_REPORT_DESCRIPTION,
	},
];

// ==========================================:

export const SPECIAL_FORMAT = 'special_format';
export const CSV_FORMAT = 'csv';
export const PDF_FORMAT = 'pdf';
export const XLSX_FORMAT = 'xlsx';
export const XML_FORMAT = 'xml';
export const TXT_FORMAT = 'txt';
